import { HTMLAttributes, ReactNode } from "react";
import { Variant } from "react-bootstrap/esm/types";
import classNames from "clsx";

type TimelineProps = HTMLAttributes<HTMLDivElement> & {
	children: ReactNode;
};

function TimelineRoot({ children, className, ...rest }: TimelineProps) {
	return (
		<div className={classNames("timeline-label", className)} {...rest}>
			{children}
		</div>
	);
}

function TimelineItem({ children, className, ...rest }: TimelineProps) {
	return (
		<div className={classNames("timeline-item", className)} {...rest}>
			{children}
		</div>
	);
}

function TimelineLabel({ children, className, ...rest }: TimelineProps) {
	return (
		<div
			className={classNames("timeline-label fw-bold text-gray-800 fs-6", className)}
			{...rest}
		>
			{children}
		</div>
	);
}

type TimelineContentProps = TimelineProps & {
	badgeContainerClassName?: string;
	badgeIconClassName?: string;
	variant?: Variant;
};

function TimelineContent({
	children,
	className,
	badgeContainerClassName,
	badgeIconClassName,
	variant = "primary",
	...rest
}: TimelineContentProps) {
	return (
		<>
			<div className={classNames("timeline-badge", badgeContainerClassName)}>
				<i
					className={classNames(
						`fa fa-genderless fs-1 text-${variant}`,
						badgeIconClassName
					)}
				></i>
			</div>

			<div className={classNames("timeline-content ps-3", className)} {...rest}>
				{children}
			</div>
		</>
	);
}

export const Timeline = TimelineRoot as typeof TimelineRoot & {
	Item: typeof TimelineItem;
	Label: typeof TimelineLabel;
	Content: typeof TimelineContent;
};

Timeline.Item = TimelineItem;
Timeline.Label = TimelineLabel;
Timeline.Content = TimelineContent;
